import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
    CreateSisterCompanyAccessRequest,
    DecideSisterCompanyAccessRequest,
    SisterCompanyAccessContext,
    SisterCompanyAccessRequest
} from './tenant-access.model';

@Injectable({ providedIn: 'root' })
export class SisterCompanyAccessService {
    private readonly apiUrl = `${environment.restApiUrl}sister-company-access-requests`;

    constructor(private readonly http: HttpClient) {}

    getContext() {
        return this.http.get<SisterCompanyAccessContext>(`${this.apiUrl}/context`);
    }

    create(request: CreateSisterCompanyAccessRequest) {
        return this.http.post<SisterCompanyAccessRequest>(this.apiUrl, request);
    }

    getOutbox() {
        return this.http.get<SisterCompanyAccessRequest[]>(`${this.apiUrl}/outbox`);
    }

    getInbox() {
        return this.http.get<SisterCompanyAccessRequest[]>(`${this.apiUrl}/inbox`);
    }

    approve(requestId: number, request: DecideSisterCompanyAccessRequest) {
        return this.http.post<SisterCompanyAccessRequest>(`${this.apiUrl}/${requestId}/approve`, request);
    }

    reject(requestId: number, reason?: string) {
        return this.http.post<SisterCompanyAccessRequest>(`${this.apiUrl}/${requestId}/reject`, { reason });
    }

    amendRoles(requestId: number, request: DecideSisterCompanyAccessRequest) {
        return this.http.put<SisterCompanyAccessRequest>(`${this.apiUrl}/${requestId}/roles`, request);
    }

    revoke(requestId: number, reason?: string) {
        return this.http.post<SisterCompanyAccessRequest>(`${this.apiUrl}/${requestId}/revoke`, { reason });
    }
}
